// extracted by mini-css-extract-plugin
export var copyIcon = "_z7-2";
export var discountCard = "_z7-0";
export var discountCode = "_z7-3";
export var discountContent = "_z7-1";
export var loadingCard = "_z7-4";